import { LoadingSpinner, Button, ButtonType } from '@soteria/design-system-ve';

import * as styles from './ActionButtons.css';

interface ActionButtonsProps {
  hasContent: boolean;
  isLoading: boolean;
  onClassify: () => void;
}

/**
 * ActionButtons component to render the classify button and instructions
 * Extracts button section logic from the main component
 */
export function ActionButtons({ hasContent, isLoading, onClassify }: ActionButtonsProps) {
  return (
    <div className={styles.buttonSection}>
      <div className={styles.instructionText}>Press Ctrl + Enter to classify</div>
      <div className={styles.buttonContainer}>
        <Button buttonType={ButtonType.Brand} className={styles.classifyButton} disabled={!hasContent || isLoading} onClick={onClassify}>
          {isLoading ? <LoadingSpinner /> : 'CLASSIFY'}
        </Button>
      </div>
    </div>
  );
}
